// extracted by mini-css-extract-plugin
module.exports = {"label":"BaseRadioGroup_label_mhyO0","radio-button":"BaseRadioGroup_radio-button_3S_YI"};